import axiosInstance from './axios-instance';
import { isMutationSuccess } from './cache-utils';
import { invalidateProjectDataCache, resolveClientId } from './cache-invalidation';

const getScopedAccountId = (accountId?: number): number => {
  if (typeof window === 'undefined') {
    return Number(accountId || 0);
  }
  const ownerAccountId = Number(localStorage.getItem('ownerAccountId') || '0');
  if (ownerAccountId > 0) {
    return ownerAccountId;
  }
  if (Number(accountId) > 0) {
    return Number(accountId);
  }
  return Number(localStorage.getItem('accountId') || '0');
};

const getProjects = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`projects/get-all`, {
      ...payload,
      accountId: getScopedAccountId(payload?.accountId),
    });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const updateProject = async (projectId: any, payload: any) => {
  try {
    const response = await axiosInstance.post(`projects/update/${projectId}`, payload);
    if (isMutationSuccess(response.data)) {
      invalidateProjectDataCache(resolveClientId(payload, response.data));
    }

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const deleteProject = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`projects/delete`, payload);
    if (isMutationSuccess(response.data)) {
      invalidateProjectDataCache(resolveClientId(payload, response.data));
    }

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const archiveProjects = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`projects/archive`, payload);
    if (isMutationSuccess(response.data)) {
      invalidateProjectDataCache(resolveClientId(payload, response.data));
    }

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const addProject = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`projects/addProject`, {
      ...payload,
      accountId: getScopedAccountId(payload?.accountId),
    });
    if (isMutationSuccess(response.data)) {
      invalidateProjectDataCache(resolveClientId(payload, response.data));
    }

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const updateLastViewed = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`projects/lastViewed`, payload)
    
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export { getProjects, updateProject, deleteProject, archiveProjects, addProject, updateLastViewed };
